/**
 * @since 2023-10-30
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import "./TextCopyright.scss";

const TextCopyright = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="textCopyright">
      © {currentYear} AlgoTraders. All Rights Reserved. Patent US-12271950-B2.
      <br />
    </div>
  );
};

export default TextCopyright;
